module.exports = __webpack_public_path__ + "img/quirofanosql.765fc6fc.png";